import React, { FC } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Modal, Text, Button } from '../../components';

export interface UomChangeConfirmationModalProps {
  open: boolean;
  engineValue: string | number;
  engineUom: string;
  fromValue: string | number;
  fromUom: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const UomChangeConfirmationModal: FC<UomChangeConfirmationModalProps> = ({
  open,
  engineValue,
  engineUom,
  fromValue,
  fromUom,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  const message = t('cloud_dvir__uom_change_confirmation', {
    engineValue,
    engineUom,
    fromValue,
    fromUom,
  });

  return (
    <Modal open={open} onClose={onCancel}>
      <Box sx={{
        display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center',
      }}
      >
        <Text
          fontLevel="title"
          fontSize="large"
          sx={{ color: (theme) => theme.palette.neutral.variation40 }}
        >
          {t('cloud_dvir__uom_change_confirmation_title')}
        </Text>
        <Text sx={{ textAlign: 'center' }}>{message}</Text>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button isFilled size="small" onClick={onConfirm}>{t('yes')}</Button>
          <Button isFilled viewType="secondary" size="small" onClick={onCancel}>{t('no')}</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UomChangeConfirmationModal;
